import { useApp } from '../../store/AppContext'
import { Radio } from 'lucide-react'

const LIVE_THRESHOLD = 120_000 // 2 minutes

export default function LiveBanner() {
    const { allBoatsLiveData, playbackState, switchToLive, t } = useApp()

    const isPlayback = playbackState.frames.length > 0

    // Only show during playback
    if (!isPlayback) return null

    // Find boats with recent data
    const now = Date.now()
    const liveBoats: Array<{ id: string, ago: number }> = []

    allBoatsLiveData.forEach((data, boatId) => {
        const age = now - data.timestamp
        if (age < LIVE_THRESHOLD) {
            liveBoats.push({ id: boatId, ago: age })
        }
    })

    if (liveBoats.length === 0) return null

    return (
        <div className="absolute bottom-28 left-1/2 -translate-x-1/2 z-20 animate-slide-up">
            <div className="glass-dark rounded-xl px-4 py-3 shadow-2xl border border-red-500/30 flex items-center gap-3 max-w-lg">
                {/* Pulsing dot */}
                <span className="relative flex h-3 w-3 shrink-0">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" />
                </span>

                {/* Info */}
                <div className="flex-1 min-w-0">
                    <div className="text-xs text-white/60 mb-0.5">
                        {liveBoats.length} {t('liveBanner.boatsLive')}
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                        {liveBoats.map(b => (
                            <button
                                key={b.id}
                                onClick={() => switchToLive(b.id)}
                                className="px-2 py-0.5 bg-white/10 hover:bg-white/20 rounded text-xs text-white font-mono transition-colors truncate"
                                title={`Switch to ${b.id} live`}
                            >
                                {b.id}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Switch button */}
                <button
                    onClick={() => switchToLive()}
                    className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 bg-red-500/20 hover:bg-red-500/30 border border-red-500/40 rounded-lg text-red-400 text-xs font-semibold transition-colors"
                >
                    <Radio className="w-3.5 h-3.5" />
                    {t('liveBanner.switchToLive')}
                </button>
            </div>
        </div>
    )
}
